import { useEffect, useRef } from 'react';
import { useGameStore } from '../stores/gameStore';

export const useBrickLoop = (canvasRef: React.RefObject<HTMLCanvasElement>) => {
  const loopRef = useRef<number>();
  const lastTimeRef = useRef<number>(0);

  const { brickTick, brick } = useGameStore();

  useEffect(() => {
    const step = (time: number) => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      const dt = Math.min((time - lastTimeRef.current) / 1000, 0.05);
      lastTimeRef.current = time;

      if (brick.phase === 'playing') {
        brickTick(dt);
      }

      const gameWidth = 160;
      const gameHeight = 120;
      const width = canvas.width;
      const height = canvas.height;
      const scaleX = width / gameWidth;
      const scaleY = height / gameHeight;

      ctx.setTransform(scaleX, 0, 0, scaleY, 0, 0);
      ctx.clearRect(0, 0, gameWidth, gameHeight);

      // Background
      ctx.fillStyle = '#001100';
      ctx.fillRect(0, 0, gameWidth, gameHeight);

      // Grid lines
      ctx.strokeStyle = 'rgba(0, 255, 0, 0.1)';
      ctx.lineWidth = 1 / Math.max(scaleX, scaleY);
      for (let y = 0; y < gameHeight; y += 8) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(gameWidth, y);
        ctx.stroke();
      }

      // Bricks
      brick.bricks.forEach((b) => {
        if (b.destroyed) return;
        ctx.fillStyle = b.hitPoints > 1 ? '#00ff66' : '#00aa00';
        ctx.fillRect(b.x, b.y, b.width, b.height);
      });

      // Paddle
      ctx.fillStyle = '#00ff66';
      const paddleY = gameHeight - 12;
      ctx.fillRect(brick.paddleX, paddleY, brick.paddleWidth, 4);

      // Ball
      ctx.beginPath();
      ctx.arc(brick.ballX, brick.ballY, 3, 0, Math.PI * 2);
      ctx.fill();

      // HUD
      ctx.fillStyle = '#00ff66';
      ctx.font = "8px 'Courier New', monospace";
      ctx.textBaseline = 'top';
      ctx.fillText(
        `SCORE: ${brick.score.toString().padStart(4, '0')}`,
        2,
        2
      );
      ctx.fillText(`LIVES: ${brick.lives}`, gameWidth - 44, 2);
      ctx.fillText(`LVL: ${brick.level}`, gameWidth - 44, 10);

      loopRef.current = requestAnimationFrame(step);
    };

    lastTimeRef.current = performance.now();
    loopRef.current = requestAnimationFrame(step);

    return () => {
      if (loopRef.current) cancelAnimationFrame(loopRef.current);
    };
  }, [brick, brickTick, canvasRef]);
};

